/**
 * Ajax Loader, Browser History and other helpers
 */
import $ from 'jquery';

const ajaxHelper = {
    ajaxLoader: (url, target, type, data, loading, successCallback = () => {}, failureCallback = () => {}) => {
        // Is it an id target
        if ($('#' + target).length > 0) {
            target = '#' + target;
        } else {
            // Or an class target
            if ($('.' + target).length > 0) {
                target = '.' + target;
            }
        }

        // Stop current request
        if (window.xhr[target] !== undefined && typeof window.xhr[target].abort === 'function') {
            window.xhr[target].abort();
        }

        // Target exists
        if ($(target).length > 0) {
            // Show loading
            if (loading == true) {
                $(target).addClass('whirl');
            }

            // Start new request
            window.xhr[target] = $.ajax({
                url: url,
                type: type,
                data: data,
                async: true,
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                success: function (data) {
                    $(target).html(data);
                    $(target).removeClass('whirl');
                    if (typeof successCallback === "function") {
                        successCallback();
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $(target).removeClass('whirl');
                    console.log("Ajax failed! " + textStatus);

                    if (typeof failureCallback === "function") {
                        failureCallback();
                    }
                },
            });
        }
    },

    /* Upload ajax loader function */
    ajaxUploader: (url, target, type, data, loading, progress, successCallback = () => {}, failureCallback = () => {}) => {
        // Is it an id target
        if ($('#' + target).length > 0) {
            target = '#' + target;
        } else {
            // Or an class target
            if ($('.' + target).length > 0) {
                target = '.' + target;
            }
        }

        // Progress bar exists
        if (progress !== undefined && progress.length > 0) {
            progress.removeClass('d-none');
            progress.attr('aria-valuenow', '0');
            progress.find('.progress-bar').css('width', '0%');
            progress.find('.progress-bar').html('0%');
        }

        // Stop current request
        if (window.xhr[target] !== undefined && typeof window.xhr[target].abort === 'function') {
            window.xhr[target].abort();
        }

        // Target exists
        if ($(target).length > 0) {
            // Show loading
            if (loading == true) {
                $(target).addClass('whirl');
            }

            // Define progress variables
            const startTime = new Date().getTime();
            let bytesTotal = 0;

            // Start new request
            window.xhr[target] = $.ajax({
                url: url,
                type: type,
                data: data,
                async: true,
                contentType: false,
                processData: false,
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                xhr: function() {
                    var xhr = new window.XMLHttpRequest();
                    xhr.upload.addEventListener("progress", function(evt) {
                        if (evt.lengthComputable) {
                            let now = new Date().getTime();
                            let percent = parseInt(evt.loaded * 100 / evt.total);
                            let elapsed = (now - startTime) / 1000;

                            bytesTotal = evt.total;

                            let kbps = 0;
                            let remaining = 0;

                            if (elapsed) {
                                let bps = evt.loaded / elapsed;
                                kbps = bps / 1024;
                                remaining = Math.round((evt.total - evt.loaded) / bps);
                            }

                            // Update progress bar
                            if (progress !== undefined && progress.length > 0) {
                                progress.attr('aria-valuenow', percent);
                                progress.find('.progress-bar').css('width', percent + '%');
                                progress.find('.progress-bar').html(percent + '%');
                            }

                            console.log('Percent: ' + percent + '%% ' + kbps.toFixed(2) + ' KB/s ' + remaining + ' sec');
                        }
                    }, false);

                    return xhr;
                },
                success: function (data) {
                    $(target).html(data);
                    $(target).removeClass('whirl');

                    // Hide progress bar
                    if (progress !== undefined && progress.length > 0) {
                        progress.addClass('d-none');
                    }

                    successCallback();
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    $(target).removeClass('whirl');
                    console.log("Upload failed! " + textStatus);

                    failureCallback();
                },
            });
        }
    },
}

/* Make it global available */
window.ajaxHelper = ajaxHelper;

$(function () {
    "use strict";

    let History = window.history || undefined;
    window.xhr = [];

    /* Auto submit form */
    if ($('.auto_submit').length > 0) {
        $('.auto_submit').trigger('submit');
    }

    /* Auto click form */
    if($('.auto_click').length > 0) {
        $('.auto_click').trigger('click');
    }

    /* Auto hide */
    if ($('.auto_hide').length > 0) {
        $('.auto_hide').each(function (element) {
            let delay = $(this).data('delay');

            if (delay !== undefined && delay !== '' && delay > 0) {
                setTimeout(function (elem) {
                    $(elem).hide(1000);
                }, delay, this);
            }
        });
    }

    /* Auto redirect */
    if ($('.redirect').length > 0) {
        let url = $('.redirect').data('url');

        // URL is defined
        if (url !== null && url !== '' && url !== undefined) {
            top.location.href = url;
        }
    }

    /* Show loading indicator */
    $(document).on('submit', '.show_loading', function(e) {
        // Get attributes
        var target = $(this).data('target');

        // Is it an id target
        if ($('#' + target).length > 0) {
            target = '#' + target;
        } else {
            // Or an class target
            if ($('.' + target).length > 0) {
            target = '.' + target;
            }
        }
        // Target exists
        if ($(target).length > 0) {
            $(target).addClass('whirl');
        }
    });

    /* Load in modal */
    $(document).on('click', 'a.ajax_modal', function (e) {
        e.preventDefault();
        // Get attributes
        let url = $(this).attr('href');
        let type = $(this).data('type');
        let size = $(this).data('size');
        let modal = $(this).data('modal');
        let positioning = $(this).data('positioning');
        let backdrop = $(this).data('backdrop');
        let keyboard = $(this).data('keyboard');
        let success = $(this).data('success');
        let failure = $(this).data('failure');

        // Check if modal is set
        if (modal === undefined || modal === '' || $('#' + modal).length === 0) {
            modal = 'modal';
        }

        // Modal or content does not exist
        if ($('#' + modal).length === 0 || $('#' + modal + ' .modal-dialog').length === 0) {
            return;
        }

        // Set centering
        $('#' + modal + ' .modal-dialog').toggleClass('modal-dialog-centered', positioning === "centered");

        // Reset size
        $('#' + modal + ' .modal-dialog').removeClass('modal-sm modal-lg modal-xl');

        // Add size if applicable
        if ($.inArray(size, ["sm", "lg", "xl"]) !== -1) {
            $('#' + modal + ' .modal-dialog').addClass('modal-' + size);
        }

        // Open modal
        $('#' + modal).modal('show');
        // Clear content
        $('#' + modal + ' .modal-dialog').html('');

        // Callbacks
        let callbackSuccess = () => {};
        let callbackFailure = () => {};

        // Handle success callback
        if (typeof window[success] === "function") {
            callbackSuccess = window[success]();
        }

        // Handle failure callback
        if (typeof window[failure] === "function") {
            callbackFailure = window[failure]();
        }

        // Get instance of modal
        let modalInstance = bootstrap.Modal.getOrCreateInstance($('#' + modal));

        // Do we have an instance
        if (modalInstance && modalInstance._config) {
            modalInstance._config.backdrop = (backdrop === 'static') ? 'static' : true;
            modalInstance._config.keyboard = (keyboard === false) ? false : true;
        }

        // Get type
        if (type === undefined || type === '') {
            type = 'GET';
        }

        // Load content
        ajaxHelper.ajaxLoader(url, modal + ' .modal-dialog', type, null, true, callbackSuccess, callbackFailure);
    });

    /* Ajax link element loader */
    $(document).on('click', 'a.ajax', function (e) {
        e.preventDefault();
        // Get attributes
        let target = $(this).data('target');
        let url = $(this).attr('href');
        let type = $(this).data('type');
        let push = $(this).data('push');
        let success = $(this).data('success');
        let failure = $(this).data('failure');

        // Callbacks
        let callbackSuccess = () => {};
        let callbackFailure = () => {};

        // Handle success callback
        if (typeof window[success] === "function") {
            callbackSuccess = window[success]();
        }

        // Handle failure callback
        if (typeof window[failure] === "function") {
            callbackFailure = window[failure]();
        }

        if (type === undefined || type === '') {
            type = 'GET';
        }

        // Load content
        ajaxHelper.ajaxLoader(url, target, type, null, true, callbackSuccess, callbackFailure);

        // Push state
        if (push !== undefined && push !== '' && History !== undefined) {
            History.pushState({ path: url, target: target, type: type }, push, url);
        }
    });

    /* Ajax form element loader */
    $(document).on('submit', 'form.ajax', function (e) {
        e.preventDefault();
        // Get attributes
        let target = $(this).data('target');
        let url = $(this).attr('action');
        let type = $(this).attr('method');
        let success = $(this).data('success');
        let failure = $(this).data('failure');
        let data = $(this).serialize();

        // Callbacks
        let callbackSuccess = () => {};
        let callbackFailure = () => {};

        // Handle success callback
        if (typeof window[success] === "function") {
            callbackSuccess = window[success]();
        }

        // Handle failure callback
        if (typeof window[failure] === "function") {
            callbackFailure = window[failure]();
        }

        if (type == undefined || type == '') {
            type = 'POST';
        }

        ajaxHelper.ajaxLoader(url, target, type, data, true, callbackSuccess, callbackFailure);
    });

    /* Ajax form element loader with file upload */
    $(document).on('submit', 'form.ajax_upload', function (e) {
        e.preventDefault();
        // Get attributes
        let target = $(this).data('target');
        let url = $(this).attr('action');
        let type = $(this).attr('method');
        let success = $(this).data('success');
        let failure = $(this).data('failure');
        let data = new FormData(this);

        // Callbacks
        let callbackSuccess = () => {};
        let callbackFailure = () => {};

        // Handle success callback
        if (typeof window[success] === "function") {
            callbackSuccess = window[success]();
        }

        // Handle failure callback
        if (typeof window[failure] === "function") {
            callbackFailure = window[failure]();
        }

        // Find progress bar
        let progress = $(this).find('.progress');

        if (type == undefined || type == '') {
            type = 'POST';
        }

        ajaxHelper.ajaxUploader(url, target, type, data, true, progress, callbackSuccess, callbackFailure);
    });

    /* Content update and back/forward button handler */
    $(window).on('popstate', function (event) {
        /* We have no state object */
        if (event.state === undefined || event.state === null) {
            return;
        }

        /* We have a state object */
        if (event.state.path !== undefined && event.state.target !== undefined && event.state.type !== undefined) {
            ajaxHelper.ajaxLoader(event.state.path, event.state.target, event.state.type, null, true);
        }
    });
});
